module.exports = __webpack_public_path__ + "img/mobile_gift.0dcd4d67.png";